import { getCategories } from "@/infrastructure/services/profileService";
import { useCallback, useState } from "react";

export function useCategories() {
  const [categoryOptions, setCategoryOptions] = useState<
    { label: string; value: string }[]
  >([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  const loadCategories = useCallback(async () => {
    setIsLoading(true);
    setError("");
    try {
      const options = await getCategories();
      setCategoryOptions(options);
      return options;
    } catch (requestError) {
      const message =
        requestError instanceof Error
          ? requestError.message
          : "Não foi possível carregar as categorias.";
      setError(message);
      setCategoryOptions([]);
      throw requestError;
    } finally {
      setIsLoading(false);
    }
  }, []);
  return { categoryOptions, error, isLoading, loadCategories };
}
